import React from "react";
import classNames from "classnames";

const Content = ({ children, className }) => <div className={classNames('content', className)}>{children}</div>;

export default Content;
